import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackShowcaseSubpageAdded.meta';

export type UseTrackShowcaseSubpageAddedParams = {
  page_name: string;
};

export const useTrackShowcaseSubpageAdded = () => {
  const { track } = useAnalyticsUtilities();

  const trackShowcaseSubpageAdded = useCallback(
    (params: UseTrackShowcaseSubpageAddedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackShowcaseSubpageAdded };
};
